<path
    d="M5.66667 4C4.1939 4 3 5.1939 3 6.66667V20H9.09525V10.0952H19V4H5.66667Z"
    fill="white"
/>
<path
    d="M31 4V10.0952H40.9046V20H47V6.66667C47 5.1939 45.8062 4 44.3333 4H31Z"
    fill="white"
/>
<path
    d="M47 32H40.9046V41.9046H31V48H44.3333C45.8062 48 47 46.8062 47 45.3333V32Z"
    fill="white"
/>
<path
    d="M9.09525 41.9046H19V48H5.66667C4.1939 48 3 46.8062 3 45.3333V32H9.09525V41.9046Z"
    fill="white"
/>
